
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { parseBatchAddresses } from './utils'
import { NeoField, NeoInput } from '@kodadot1/brick'

@Component({
  components: {
    NeoField,
    NeoInput,
  },
})
export default class AddressParser extends Vue {
  @Prop({ type: Array, default: () => [], required: true }) value!: string[]

  @Emit('input')
  handleInput(event: string): string[] {
    return parseBatchAddresses(event)
  }
}
